// Global State Management
function safeJsonParse(raw, fallback) {
    if (raw == null || raw === '') {
        return fallback;
    }
    try {
        return JSON.parse(raw);
    } catch {
        return fallback;
    }
}

const parsedUser = safeJsonParse(localStorage.getItem('user_data'), null);
const parsedPerms = safeJsonParse(localStorage.getItem('permissions'), []);

export const state = {
    authToken: localStorage.getItem('auth_token') || null,
    user: parsedUser && typeof parsedUser === 'object' ? parsedUser : null,
    permissions: Array.isArray(parsedPerms) ? parsedPerms : [],
    currentView: localStorage.getItem('current_view') || 'dashboard'
};

// State observers
const observers = new Set();

export function subscribe(callback) {
    observers.add(callback);
    return () => observers.delete(callback);
}

export function updateState(updates) {
    Object.assign(state, updates);

    // Persist currentView if changed
    if (updates.currentView) {
        localStorage.setItem('current_view', updates.currentView);
    }

    observers.forEach(callback => {
        try {
            callback(state);
        } catch (error) {
            console.error('[State] Observer error:', error);
        }
    });
}

export function clearState() {
    state.authToken = null;
    state.user = null;
    state.permissions = [];
    state.currentView = 'dashboard';

    localStorage.removeItem('auth_token');
    localStorage.removeItem('user_data');
    localStorage.removeItem('permissions');

    observers.forEach(callback => {
        try {
            callback(state);
        } catch (error) {
            console.error('[State] Observer error:', error);
        }
    });
}
